const INFO_OVERLAY_CONTENT = {
  VIDEO_INFO: 'videoInfo',
  ALL_CARDS: 'allCards',
};

export default INFO_OVERLAY_CONTENT;



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/containers/animated-overlay-content/info-overlay-content-enums.js